import { useCallback } from 'react';
import { _ as _createForOfIteratorHelperLoose } from './_rollupPluginBabelHelpers-f5c76728.js';

/**
 * React custom hook that combines multiple callbacks into one.
 *
 * @example
 * import React from "react";
 * import { useAllCallbacks } from "reakit-utils";
 *
 * function Component(props) {
 *   const onClick = () => {};
 *   return (
 *     <button onClick={useAllCallbacks(onClick, props.onClick)}>Button</button>
 *   );
 * }
 */
function useAllCallbacks() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }

  return useCallback(function () {
    var fns = callbacks.filter(Boolean);

    for (var _iterator = _createForOfIteratorHelperLoose(fns), _step; !(_step = _iterator()).done;) {
      var callback = _step.value;
      callback.apply(void 0, arguments);
    }
  }, callbacks);
}

export { useAllCallbacks };
